import CUSTOM_SECTION_CONTAINER_NAMES from '@src/quince-site-common/src/constants/customSectionContainerNames'
import CUSTOM_SECTION_CONTAINER_TYPES from '@src/quince-site-common/src/constants/customSectionContainerTypes'
import { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'

export const getTrackingMetaData = (): TrackingMetaData => ({
  context: {
    contentContainerType: CUSTOM_SECTION_CONTAINER_TYPES.PRODUCT_DISPLAY,
    contentContainerName: CUSTOM_SECTION_CONTAINER_NAMES.INFINITE_LIST,
    // @i18n-ignore
    contentContainerDisplayName: 'Search Results',
    trackingId: 'searchResults',
  },
})

export const PRODUCT_CARD_OPTION_LIMIT = 5

export const PRODUCTS_LIMIT_FOR_EVENT = 20
